module.exports = __webpack_public_path__ + "img/logo-prioritet_finans_vertical.659fe0a7.svg";